import { render } from "./FAQs.vue?vue&type=template&id=e8fba62c&ts=true"
import script from "./FAQs.vue?vue&type=script&lang=ts"
export * from "./FAQs.vue?vue&type=script&lang=ts"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__